import { useState } from 'react'

// Immediate feedback while an async action is in flight: pass `submitting`
// as MUI Button's own `loading` prop (disables it and shows a spinner).
// `submit` always resets it in a `finally`, success included -- that's
// safe even when the caller navigates away on success, since the state
// update happens synchronously before the component actually unmounts.
//
//   const [submitting, submit] = useSubmitting()
//   const handleSubmit = (evt) => {
//     evt.preventDefault()
//     submit(async () => {
//       const result = await deviseFetch(...)
//       ...
//     })
//   }
//   <Button type="submit" loading={submitting}>...</Button>
//
// A list of independently-busy buttons (e.g. accept/decline per row) can't
// share one boolean -- pass a `key` identifying which one, and compare
// `submitting` against each button's own key instead of using it directly
// as a boolean:
//
//   const [answering, submit] = useSubmitting()
//   submit(fn, `${share.id}-accept`)
//   <Button loading={answering === `${share.id}-accept`} disabled={Boolean(answering)}>
export default function useSubmitting() {
  const [submitting, setSubmitting] = useState(false)

  const submit = async (fn, key = true) => {
    setSubmitting(key)
    try {
      return await fn()
    } finally {
      setSubmitting(false)
    }
  }

  return [submitting, submit]
}
